import { t } from 'i18next';
import { SectionIntro } from '../../landing/components';
import { FeatureCard } from './FeatureCard';
import { FeaturesLine } from './FeaturesLine';
import { useRef } from 'react';

export function Features() {
  const featuresRef = useRef<HTMLElement>(null);

  const featuresTitle = (
    <>
      {t('features.title.part1')}
      <i>{t('features.title.match')}</i>
      <br /> <b>{t('features.title.part2')}</b>
    </>
  );

  return (
    <section id="features" ref={featuresRef} className="section features">
      <SectionIntro title={featuresTitle} subtitle={t('features.subtitle')} />
      <div className="features_grid mt-12 flex flex-col gap-8 w-full items-center">
        <FeaturesLine>
          <FeatureCard
            title={t('features.cards.quality.title')}
            content={t('features.cards.quality.content')}
          />
          <FeatureCard
            title={t('features.cards.widget.title')}
            content={t('features.cards.widget.content')}
          />
        </FeaturesLine>
        <FeaturesLine>
          <FeatureCard
            title={t('features.cards.choice.title')}
            content={t('features.cards.choice.content')}
          />
          <FeatureCard
            title={t('features.cards.display.title')}
            content={t('features.cards.display.content')}
          />
        </FeaturesLine>
        <FeaturesLine>
          <FeatureCard
            title={t('features.cards.clipboard.title')}
            content={t('features.cards.clipboard.content')}
          />
          <FeatureCard
            title={t('features.cards.team.title')}
            content={t('features.cards.team.content')}
          />
        </FeaturesLine>
      </div>
    </section>
  );
}
